module.exports = __webpack_public_path__ + "img/image.3ad052f3.png";